
  <div class="tabs-container">
    <div class="card">
      <ion-row>
        <ion-col size-sm="10" size-md="9" size-lg="9" size-xs="10" class="pl-15 pr-0 pb-0">
          <div >
            <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndex" (selectedTabChange)="tabTypeChanged($event)">
              <mat-tab label="attendance-report">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      speed
                    </span>Attendance Report</span>
                </ng-template>
              </mat-tab>
              <mat-tab label="upcomingtraining">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      speed
                    </span>Upcoming Trainings</span>
                </ng-template>
              </mat-tab>
              <mat-tab label="reactivefeedback">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      speed
                    </span>Reactive Feedback </span>
                </ng-template>
              </mat-tab>
              <mat-tab label="joblearningfeedback">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      speed
                    </span>Job Learning Feedback</span>
                </ng-template>
              </mat-tab>
              <mat-tab label="jobbehaviorfeedback">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      speed
                    </span>Job Behavior Feedback</span>
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </div>
        </ion-col>
        <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="" class=" pl-10 pt-10 pr-10">
          <div class="center-content float-right">
            <div>
              <!-- <button type="button" class="add_btn fs-14 float-right center-content mr-5"
                [style.background-color]="buttonColorName" (click)="onClickSetup('Setup')">
                <span class="material-icons fs-20 mr-5">settings</span>Setup</button> -->
            </div>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>



  <div class="card  attritionTab">
    <div class="p-10" *ngIf="selectedTypeTabName=='attendance-report'">
      <app-attendance-report></app-attendance-report>
    </div>
  
    <div class="p-10" *ngIf="selectedTypeTabName=='upcomingtraining'">
      <app-upcoming-trainings></app-upcoming-trainings> 
    </div>
  
    <div class="p-10" *ngIf="selectedTypeTabName=='reactivefeedback'">
      <app-reactive-feedback></app-reactive-feedback>
    </div>
   <div class="p-10" *ngIf="selectedTypeTabName=='joblearningfeedback'">
      <app-job-learning-feedback></app-job-learning-feedback>
    </div>
  
  <div class="p-10" *ngIf="selectedTypeTabName=='jobbehaviorfeedback'">
      <app-job-behavior-feedback></app-job-behavior-feedback>
    </div>
  

  </div>



